/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

//search feature
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import Col from "react-bootstrap/esm/Col";
import Form from "react-bootstrap/esm/Form";
import InputGroup from "react-bootstrap/esm/InputGroup";
import { ROUTES } from "../../../utils/routes";
import Axios from "axios";
import { getAll, getByInvestigator } from "../../../utils/requests/dynamicReq";
import { paths } from "../../../utils/paths";
import { IConvocatoria } from "../../../interfaces/IConvocatoria";
import { useSelector } from "react-redux";
import { IStore } from "../../../interfaces/IStore";
import { IUser } from "../../../interfaces/IUser";
import { investigatorRoles } from "../../../utils/roles";
import { normalizer } from "../../../utils/auxiliar/investigators";
import { Table } from "react-bootstrap";

export const Convocatorias: FC = () => {
  let { staffId, isAdmin, userRoleId } = useSelector(
    ({ user }: IStore) => user as IUser
  );
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const isMountedRef = useRef(false);
  const source = Axios.CancelToken.source();
  const { CONVOCATORIAS } = paths;
  const [convocatorias, setConvocatorias] = useState<IConvocatoria[]>([]);
  const [displayConvocatorias, setDisplayConvocatorias] = useState<
    IConvocatoria[]
  >([]);
   const [sortConfig, setSortConfig] = useState<{
     key: string;
     direction: string;
   } | null>(null);
  useEffect(() => {
    setIsLoading(true);
    isMountedRef.current = true;
    loadData();
    return () => {
      isMountedRef.current = false;
      source.cancel();
    };
  }, []);

  const loadData = async () => {
    try {
      const response =
        isAdmin || userRoleId === 2 || userRoleId === 3
          ? await getAll(CONVOCATORIAS, source)
          : await getByInvestigator(
              `${CONVOCATORIAS}/investigator`,
              staffId,
              source
            );
      if (isMountedRef.current) {
        setConvocatorias(response);

        setDisplayConvocatorias(response);
      }
      setIsLoading(false);
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  const searchBar = (value: any) => {
    setDisplayConvocatorias(
      convocatorias.filter(({ nameEs }: any) =>
        normalizer(nameEs)
          .toLowerCase()
          .includes(normalizer(value).toLowerCase())
      )
    );
    !value && setDisplayConvocatorias(convocatorias);
  };
     const sortByColumn = (key: any) => {
       let direction = "desc";
       if (
         sortConfig &&
         sortConfig.key === key &&
         sortConfig.direction === "desc"
       ) {
         direction = "asc";
       }
       setSortConfig({ key, direction });
       const sortedData = [...displayConvocatorias].sort((a: any, b: any) => {
         if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
         if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
         return 0;
       });
       setDisplayConvocatorias(sortedData);
     };

     const columnHeaders: Record<string, string> = {

       nombreSubconvocatoria: "TÍTULO", // Cambio aquí, pero mantiene la clave "acronimo"
       fecha: "FECHA",
      
     };

  return (
    <div className="container-fluid p-4">
      {(isAdmin || userRoleId === 2 || userRoleId === 3) && (
        <>
          {" "}
          <div className="row">
            <div className="col d-flex justify-content-between">
              <div>
                <h3>Convocatorias</h3>
              </div>
              <div>
                <button
                  className="baseBtn"
                  onClick={() => history.push(ROUTES.Convocatorias.create)}
                >
                  + Añadir
                </button>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <Form.Group as={Col}>
              <InputGroup className="shadow">
                <InputGroup.Prepend>
                  <InputGroup.Text className="inputGroup ">
                    <FontAwesomeIcon color="#0073B5" icon={faSearch} />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="text"
                  placeholder="Buscar..."
                  className="form-control"
                  onChange={({ target: { value } }) => searchBar(value)}
                />
              </InputGroup>
            </Form.Group>
          </div>
          <div className="row">
            <Table striped bordered hover>
              <thead>
                <tr>
                  {Object.keys(columnHeaders).map((col) => (
                    <th
                      key={col}
                      onClick={() => sortByColumn(col)}
                      style={{ cursor: "pointer" }}
                    >
                      {columnHeaders[col]}{" "}
                      {sortConfig?.key === col
                        ? sortConfig.direction === "asc"
                          ? "▲"
                          : "▼"
                        : ""}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {displayConvocatorias.length > 0 ? (
                  displayConvocatorias.map(
                    ({ id, nombreSubconvocatoria, fecha }: any) => (
                      <tr
                        key={id}
                        onClick={() =>
                          history.push(`${paths.CONVOCATORIAS}/${id}`)
                        }
                      >
                        <td>{nombreSubconvocatoria}</td>
                        <td>{fecha}</td>
                      </tr>
                    )
                  )
                ) : (
                  <tr>
                    <td colSpan={6} className="text-center">
                      No hay convocatorias para mostrar
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </>
      )}
    </div>
  );
};
